import Product from '../../domains/Product'
import { IProductVariantOption } from '../../domains/ProductVariant'
import PubSub from '../PubSub'

interface PdpState {
  slug: string | null
  shopifyProductId: number | null
  selectedOptions: IProductVariantOption[]
  bundleSelectedOptions: {
    product: Product
    selectedOptions: IProductVariantOption[]
  }[]
  reviewSectionInFocus: boolean
  seoPrice?: number | null
  productId?: string
}

interface SetSelectedOptionsPayload {
  slug: string
  shopifyProductId: number
  selectedOptions: IProductVariantOption[]
  bundleSelectedOptions?: {
    product: Product
    selectedOptions: IProductVariantOption[]
  }[]
  productId?: string
}

class PdpStateManager extends PubSub {
  private state: PdpState

  constructor() {
    super()
    this.state = {
      slug: null,
      shopifyProductId: null,
      selectedOptions: [],
      bundleSelectedOptions: [],
      reviewSectionInFocus: false,
      seoPrice: null,
      productId: undefined,
    }
  }

  setSelectedOptions = (payload: SetSelectedOptionsPayload) => {
    this.state.slug = payload.slug
    this.state.shopifyProductId = payload.shopifyProductId
    this.state.selectedOptions = payload.selectedOptions
    this.state.bundleSelectedOptions = payload.bundleSelectedOptions || []
    this.state.productId = payload.productId
    this.publish()
  }

  setShowReviewSection = (payload: { reviewSectionInFocus: boolean }) => {
    this.state.reviewSectionInFocus = payload.reviewSectionInFocus
    this.publish()
  }

  setSeoPrice = (payload: { seoPrice: number }) => {
    this.state.seoPrice = payload.seoPrice
    this.publish()
  }

  getSelectedOptions = () => {
    return this.state.selectedOptions
  }
  getBundleSelectedOptions = () => {
    return this.state.bundleSelectedOptions
  }
  getReviewSectionInFocus = () => {
    return this.state.reviewSectionInFocus
  }
  getSeoPrice = () => {
    return this.state.seoPrice
  }
  getProductSlugFromRedux = () => {
    return this.state.slug
  }
  getShopifyProductIdFromRedux = () => {
    return this.state.shopifyProductId
  }
  getProductIdFromRedux = () => {
    return this.state.productId
  }
}

const pdpStateManager: PdpStateManager = PdpStateManager.getInstance('pdpStateManager')

export default pdpStateManager
